import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { ScrollToTop } from './components/layout/scrollTop/scrollToTop'

import Main from './containers/main'
import UploadDocument from './containers/uploadId'
import SignDocuments from './containers/signDocuments'
import DocumentView from './containers/document'
import ClaimForm from './components/claimForm/main'

export default function AppRouter() {
    return (
        <Router>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<Main />}>
                    <Route path="/" element={<ClaimForm />} />
                    <Route path="sign/:token" element={<SignDocuments />} />
                    <Route path="upload-id/:token" element={<UploadDocument />} />
                    <Route path="documents/:fileName" element={<DocumentView />} />
                </Route>
            </Routes>
        </Router>
    )
}
